import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';

@Component({
  selector: 'tablesready-model-name-display',
  templateUrl: './model-name-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModelNameDisplayComponent implements OnInit, OnChanges {
  @Input() id: string[] | string;
  @Input() models: Model[];

  public displayString: string = '';
  constructor(
    private readonly cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.displayString = this.displayName(this.id);
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.id && changes.id.currentValue) {
      this.displayString = this.displayName(changes.id.currentValue);
      this.cdr.detectChanges();
    }
  }

  displayName(id: string[] | string) {
    if (!id) {
      return '';
    }
    if (id instanceof Array) {
      return id.reduce((acc, id) => {
        const model = this.models.find(model => model._id === id);
        if (model && model.name) {
          acc.push(model.name);
        }

        return acc;
      }, []).join(', ');
    }

    return this.models.find(model => model._id === id)?.name || '';
  }
}

interface Model {
  _id: string;
  name: string;
}
